/**
 * PushAlarmUnconfirmedBanner — shown when the server-side wake-up push could
 * not be confirmed armed (offline, network error, or server rejection).
 * The local WaitingScreen countdown still works as long as the tab stays
 * open — this tells the user that's their only guarantee right now.
 * UI-INV-005: Leaf component — props only, no engine imports.
 */
import { TEST_IDS } from "../testing/testIds";
import styles from "./ConnectivityBanner.module.css";

export type PushAlarmUnconfirmedBannerProps = {
  visible: boolean;
};

export function PushAlarmUnconfirmedBanner({ visible }: PushAlarmUnconfirmedBannerProps) {
  if (!visible) return null;

  return (
    <div className={styles.banner} data-testid={TEST_IDS.PUSH_ALARM_UNCONFIRMED_BANNER}>
      couldn&rsquo;t confirm background alarm — keep this tab open to be woken on time
    </div>
  );
}
